"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHtmlWithMetadata = void 0;
var createRange_1 = require("./createRange");
var safeInstanceOf_1 = require("../utils/safeInstanceOf");
var validate_1 = require("../metadata/validate");
var definitionCreators_1 = require("../metadata/definitionCreators");
var NumberArrayDefinition = (0, definitionCreators_1.createArrayDefinition)((0, definitionCreators_1.createNumberDefinition)());
var CoordinatesDefinition = (0, definitionCreators_1.createObjectDefinition)({
    x: (0, definitionCreators_1.createNumberDefinition)(),
    y: (0, definitionCreators_1.createNumberDefinition)(),
});
var IsDarkModeDefinition = (0, definitionCreators_1.createBooleanDefinition)(true /*isOptional*/);
var NormalContentMetadataDefinition = (0, definitionCreators_1.createObjectDefinition)({
    type: (0, definitionCreators_1.createNumberDefinition)(true /*isOptional*/, 0 /* Normal */),
    isDarkMode: IsDarkModeDefinition,
    start: NumberArrayDefinition,
    end: NumberArrayDefinition,
});
var TableContentMetadataDefinition = (0, definitionCreators_1.createObjectDefinition)({
    type: (0, definitionCreators_1.createNumberDefinition)(false /*isOptional*/, 1 /* TableSelection */),
    isDarkMode: IsDarkModeDefinition,
    tableId: (0, definitionCreators_1.createStringDefinition)(),
    firstCell: CoordinatesDefinition,
    lastCell: CoordinatesDefinition,
});
/**
 * @deprecated Use setHtmlWithMetadata instead
 * Restore inner HTML of a root element from given html string. If the string contains selection path,
 * remove the selection path and return a range represented by the path
 * @param root The root element
 * @param html The HTML to restore
 * @param trustedHTMLHandler An optional trusted HTML handler to convert HTML string to security string
 * @returns A selection range if the html contains a valid selection path, otherwise null
 */
function setHtmlWithSelectionPath(rootNode, html, trustedHTMLHandler) {
    var metadata = setHtmlWithMetadata(rootNode, html, trustedHTMLHandler);
    return (metadata === null || metadata === void 0 ? void 0 : metadata.type) == 0 /* Normal */
        ? (0, createRange_1.default)(rootNode, metadata.start, metadata.end)
        : null;
}
exports.default = setHtmlWithSelectionPath;
/**
 * Restore inner HTML of a root element from given html string. If the string contains metadata,
 * remove it from DOM tree and return the metadata
 * @param root The root element
 * @param html The HTML to restore
 * @param trustedHTMLHandler An optional trusted HTML handler to convert HTML string to security string
 * @returns Content metadata if any, or undefined
 */
function setHtmlWithMetadata(rootNode, html, trustedHTMLHandler) {
    if (!rootNode) {
        return undefined;
    }
    html = html || '';
    rootNode.innerHTML = (trustedHTMLHandler === null || trustedHTMLHandler === void 0 ? void 0 : trustedHTMLHandler(html)) || html;
    var potentialMetadataComment = rootNode.lastChild;
    if ((0, safeInstanceOf_1.default)(potentialMetadataComment, 'Comment')) {
        try {
            var obj = JSON.parse(potentialMetadataComment.nodeValue || '');
            if ((0, validate_1.default)(obj, NormalContentMetadataDefinition) ||
                (0, validate_1.default)(obj, TableContentMetadataDefinition)) {
                rootNode.removeChild(potentialMetadataComment);
                obj.type = typeof obj.type === 'undefined' ? 0 /* Normal */ : obj.type;
                obj.isDarkMode = obj.isDarkMode || false;
                return obj;
            }
        }
        catch (_a) { }
    }
    return undefined;
}
exports.setHtmlWithMetadata = setHtmlWithMetadata;
//# sourceMappingURL=setHtmlWithSelectionPath.js.map